/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Pc_Cmp_R_PriceInputs */

const en_pc_cmp_r_price = /** @type {(inputs: Pc_Cmp_R_PriceInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Price`)
};

const zh_pc_cmp_r_price = /** @type {(inputs: Pc_Cmp_R_PriceInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`价格`)
};

/**
* | output |
* | --- |
* | "Price" |
*
* @param {Pc_Cmp_R_PriceInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const pc_cmp_r_price = /** @type {((inputs?: Pc_Cmp_R_PriceInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Pc_Cmp_R_PriceInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_pc_cmp_r_price(inputs)
	return zh_pc_cmp_r_price(inputs)
});
export { pc_cmp_r_price as "pc.cmp.r.price" }